import styled, { keyframes } from 'styled-components'

export const AboutContainer = styled.div`
    background-color: #282C34;
    color: white;
    padding: 64px 0 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;;
    width: 100%;
    position: relative; /* Ensures absolute elements are contained */
    overflow: hidden; /* Prevents unwanted horizontal scrolling */

    p:nth-child(1){
     color: #E9011F;
     font-size: 1.3em;
     text-align: center;
     font-weight: 500;

      @media (max-width: 550px) {
        /* Phones */
        font-size: 1em;
      }

      @media (max-width: 1100px) {
        /* Tablets */
        font-size: 1em;
      }
     
    }

    h1{
        font-size: 2.2em;
        margin: 24px 0;
        text-align: center;
        
        @media (max-width: 550px) {
          /* Phones */
          font-size: 2em;
        }

        @media (max-width: 1100px) {
          /* Tablets */
          font-size: 2em;
        }
    }

    p:nth-child(3){
      text-align: center;
      width: 40%;
      color: #B3B3B3;
      margin-bottom: 24px;

      @media (max-width: 550px) {
        /* Phones */
        width: 90%;
      }

      @media (max-width: 1100px) {
        /* Tablets */
        width: 90%;
      }
    }
`

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const ImageSection = styled.div`
width: 50%;
bottom: -4em;
  position: absolute;
  opacity: 0.2;
  right: -281px;
  animation: ${rotate} 10s linear infinite; /* Rotation animation */
  transform-origin: center; /* Ensures smooth rotation */
`